/**
 * AI raporunun iframe'de gösterimi — kart önizlemesi ve rapor sekmesi aynı kuralları kullanır.
 *
 * İçerik SANDBOX'lı iframe'de: modelden geliyor ve uygulamanın DOM'una, çerezlerine
 * erişmemeli. `allow-same-origin` BİLİNÇLİ verilmiyor; yazdırma köprüsü için yalnız
 * `allow-scripts` var (Razor şablon penceresiyle aynı yaklaşım).
 */

/** Yazdırma köprüsü: dışarıdan gelen postMessage ile iframe kendini yazdırır. */
export const PRINT_MESSAGE = 'octo-ai-print';

export const REPORT_SANDBOX = 'allow-scripts allow-modals allow-popups';

export function buildSrcDoc(html: string): string {
  // Kapanış etiketi parçalı yazılıyor: kaynak dosyadaki `</script>` tarayıcıya erken
  // kapanış gibi görünmesin.
  const bridge =
    `<script>window.addEventListener('message',function(e){` +
    `if(e.data===${JSON.stringify(PRINT_MESSAGE)}){window.focus();window.print();}});` +
    `</scr` +
    `ipt>`;
  // Belge tam bir HTML sayfasıysa köprü </body>'den önce, değilse sonuna eklenir.
  return /<\/body>/i.test(html) ? html.replace(/<\/body>/i, `${bridge}</body>`) : `${html}${bridge}`;
}

/** iframe'e yazdır der. */
export function printFrame(frame: HTMLIFrameElement | null) {
  frame?.contentWindow?.postMessage(PRINT_MESSAGE, '*');
}
